import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "fury-time-scheduler-table",
  templateUrl: "./time-scheduler-table.component.html",
  styleUrls: ["./time-scheduler-table.component.scss"],
})
export class TimeSchedulerTableComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() displayedColumns: string[];
  @Input() dataSource = [];
  @Output() checkSchedule = new EventEmitter<any>();
  @Input() clearCellSelection = false;
  ngUnsubscribe = new Subject<void>();
  selectedSchedule = new Set<any>();
  constructor() {}

  ngOnInit() {}
  handleScheduleClick(columnName, time, row) {
    let val = null;
    if (this.selectedSchedule.has(columnName)) {
      this.selectedSchedule.delete(columnName);
    } else {
      this.selectedSchedule.clear();
      this.selectedSchedule.add(columnName);
    }
    if (time) {
      val = {
        isScheduled: true,
        columnName,
        startTime: row[columnName + "startTime"],
        endTime: row[columnName + "endTime"],
        isSelected: this.selectedSchedule.has(columnName),
      };
    } else {
      val = {
        isScheduled: false,
        columnName,
        startTime: columnName,
        endTime: null,
        isSelected: this.selectedSchedule.has(columnName),
      };
    }
    this.checkSchedule.emit(val);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.clearCellSelection?.currentValue)
      this.selectedSchedule.clear();
  }
  getScheduleDate(element, scheduleDate: any) {
    if (element.hasOwnProperty(scheduleDate)) {
      return element[scheduleDate] || "";
    }
    return "";
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
